import { language as lan_navigationConfig } from "./store-product-setting-navigation-config";
import { language as lan_product } from "./product/product";
import { language as lan_design } from "./design/design";
import { language as lan_mockup } from "./mockup/mockup";
import { language as lan_info } from "./info/info";
import { language as lan_pricing } from "./pricing/index";

let language = {
    // 步骤导航
    ...lan_navigationConfig,
    // 产品详细
    ...lan_product,
    // 产品定制
    ...lan_design,
    // 产品图片
    ...lan_mockup,
    // 产品信息
    ...lan_info,
    // 产品价格
    ...lan_pricing,

    // 底部操作按钮
    STORE_PRODUCT_SETTING_BACK_BTN: "返回",
    STORE_PRODUCT_SETTING_BACK_PRODUCT_BTN:"返回产品",
    STORE_PRODUCT_SETTING_GO_INFO_BTN: "继续到信息",
    STORE_PRODUCT_SETTING_GO_DESIGN_BTN: "前往设计",
    STORE_PRODUCT_SETTING_GO_CARD_RARITY_BTN: "前往稀有卡库",
    STORE_PRODUCT_SETTING_BACK_CARD_RARITY_BTN: "返回稀有卡库",
    STORE_PRODUCT_SETTING_GO_MOCKUP_BTN: "继续到模型",
    STORE_PRODUCT_SETTING_PROCEED_DESIGN_BTN:"继续到定制",
    STORE_PRODUCT_SETTING_GO_PRICING_BTN: "继续到定价",
    STORE_PRODUCT_SETTING_SAVE_PRODUCT_BTN: "保存产品",
    STORE_PRODUCT_SETTING_UPDATE_PRODUCT_BTN: "更新产品",
    STORE_PRODUCT_SETTING_SAVE_BTN: "保存"
};

export { language };
